import { cva } from "../../styled-system/css";

export const textLabel = cva({
  base: {
    color: 'text.secondary',
    fontSize: '14px',
    fontWeight: '400',
  }
})

export const text = cva({
  base: {
    color: 'text.primary',
    fontSize: '16px',
    fontWeight: '400',
  }
})

export const textWithLabelWrapper = cva({
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  }
});